import { Text } from "@chakra-ui/react"
import React from "react"
import { useSelector } from "react-redux"
import { territoriesSelectors } from "~/redux/state/territories"
import { RootState } from "~/redux/store"

interface Props {
  code: string
}

const AdressCountry: React.FC<Props> = ({ code }) => {
  const country = useSelector((state: RootState) =>
    territoriesSelectors.selectCountryByCode(state, code)
  )

  return <Text>{country?.name}</Text>
}

export default AdressCountry
